import React, { ReactNode } from 'react';
import classNames from 'classnames';
import styles from './styles/ItemCard.module.css';

type ItemCardProps = {
	children?: ReactNode;
	className?: string;
};

const ItemCard = ({ children, className }: ItemCardProps) => (
	<div className={classNames(styles.container, className)}>
		{children}
	</div>
);

export default ItemCard;
